import React from 'react'
import HeroSlide from './hero-slider-single-slide'

const HeroSlider = ({ slides }) => {

  return (
    <div className="hero-slider">
      {slides?.map(slide => (
        <HeroSlide slide={slide} key={slide.id}/>
      ))}      
    </div>
  )
}

export default HeroSlider